import React from 'react'

import Dialog from '@material-ui/core/Dialog'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Button from '@material-ui/core/Button'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import Switch from '@material-ui/core/Switch'
import Select from '@material-ui/core/Select'
import Slider from '@material-ui/core/Slider'
import Typography from '@material-ui/core/Typography'

import '../styles/cameraSetting.scss'

export default function CameraSetting(props) {
    const {
        detectionMode,
        enableDetection,
        sensitivity,
        isPreview,
        isPaintSize,
        isFree,
        isNightVision,
        isAutoLowLight,
        recordNativeResolution,
        testVideo,
        debugView,
        runPipeline,
        testImage,
        globalInfereceInterval,

        closeDialog,
        updateCameraStatus,
        isOpen,
    } = props

    return (
        <Dialog
            className="camera-setting-modal"
            onClose={closeDialog}
            aria-labelledby="simple-dialog-title"
            open={isOpen}
        >
            <p style={{ paddingLeft: '20px' }}>
                {isFree ? 'Free/Plus User' : 'Premium User'}
            </p>
            <List
                style={{ marginTop: 0, paddingTop: '0 !important' }}
                className="setting-dialog"
            >
                <ListItem className="setting-item">
                    <InputLabel className={`setting-item__label`}>
                        debugView
                    </InputLabel>
                    <ListItemSecondaryAction>
                        <Switch
                            onChange={(event) =>
                                updateCameraStatus({
                                    debugView: event.target.checked,
                                }) && event.stopPropagation()
                            }
                            checked={debugView}
                        />
                    </ListItemSecondaryAction>
                </ListItem>

                <ListItem className="setting-item">
                    <InputLabel className={`setting-item__label`}>
                        runPipeline
                    </InputLabel>
                    <ListItemSecondaryAction>
                        <Switch
                            onChange={(event) =>
                                updateCameraStatus({
                                    runPipeline: event.target.checked,
                                }) && event.stopPropagation()
                            }
                            checked={runPipeline}
                        />
                    </ListItemSecondaryAction>
                </ListItem>

                <ListItem className="setting-item">
                    <InputLabel className={`setting-item__label`}>
                        recordNativeResolution
                    </InputLabel>
                    <ListItemSecondaryAction>
                        <Switch
                            onChange={(event) =>
                                updateCameraStatus({
                                    recordNativeResolution:
                                        event.target.checked,
                                }) && event.stopPropagation()
                            }
                            checked={recordNativeResolution}
                        />
                    </ListItemSecondaryAction>
                </ListItem>

                <ListItem className="setting-item">
                    <InputLabel className={`setting-item__label`}>
                        isPreview
                    </InputLabel>
                    <ListItemSecondaryAction>
                        <Switch
                            onChange={(event) =>
                                updateCameraStatus({
                                    isPreview: event.target.checked,
                                }) && event.stopPropagation()
                            }
                            checked={isPreview}
                        />
                    </ListItemSecondaryAction>
                </ListItem>

                <ListItem className="setting-item">
                    <InputLabel className={`setting-item__label`}>
                        isPaintSize
                    </InputLabel>
                    <ListItemSecondaryAction>
                        <Switch
                            onChange={(event) =>
                                updateCameraStatus({
                                    isPaintSize: event.target.checked,
                                }) && event.stopPropagation()
                            }
                            checked={isPaintSize}
                        />
                    </ListItemSecondaryAction>
                </ListItem>

                <ListItem className="setting-item">
                    <InputLabel className={`setting-item__label`}>
                        isNightVision
                    </InputLabel>
                    <ListItemSecondaryAction>
                        <Switch
                            onChange={(event) =>
                                updateCameraStatus({
                                    isNightVision: event.target.checked,
                                }) && event.stopPropagation()
                            }
                            checked={isNightVision}
                        />
                    </ListItemSecondaryAction>
                </ListItem>

                <ListItem className="setting-item">
                    <InputLabel className={`setting-item__label`}>
                        isAutoLowLight
                    </InputLabel>
                    <ListItemSecondaryAction>
                        <Switch
                            onChange={(event) =>
                                updateCameraStatus({
                                    isAutoLowLight: event.target.checked,
                                }) && event.stopPropagation()
                            }
                            checked={isAutoLowLight}
                        />
                    </ListItemSecondaryAction>
                </ListItem>

                <br />

                <ListItem className="setting-item">
                    <InputLabel className={`setting-item__label`}>
                        enableDetection
                    </InputLabel>
                    <ListItemSecondaryAction>
                        <Switch
                            onChange={(event) =>
                                updateCameraStatus({
                                    enableDetection: event.target.checked,
                                }) && event.stopPropagation()
                            }
                            checked={enableDetection}
                        />
                    </ListItemSecondaryAction>
                </ListItem>

                <ListItem className="setting-item">
                    <InputLabel
                        htmlFor="micrphone-selector"
                        className={`setting-item__label`}
                    >
                        detectionMode
                    </InputLabel>
                    <FormControl className="setting-item__switch">
                        <Select
                            value={detectionMode}
                            onChange={(event) =>
                                updateCameraStatus({
                                    detectionMode: event.target.value,
                                }) && event.stopPropagation()
                            }
                        >
                            <MenuItem value="motion">motion</MenuItem>
                            <MenuItem value="person">person</MenuItem>
                        </Select>
                    </FormControl>
                </ListItem>

                <ListItem className="setting-item">
                    <InputLabel
                        htmlFor="micrphone-selector"
                        className={`setting-item__label`}
                    >
                        sensitivity
                    </InputLabel>
                    <FormControl className="setting-item__switch">
                        <Select
                            value={sensitivity}
                            onChange={(event) =>
                                updateCameraStatus({
                                    sensitivity: Number(event.target.value),
                                }) && event.stopPropagation()
                            }
                        >
                            <MenuItem value={1}>Low</MenuItem>
                            <MenuItem value={2}>Medium</MenuItem>
                            <MenuItem value={3}>High</MenuItem>
                        </Select>
                    </FormControl>
                </ListItem>
                <ListItem className="setting-item">
                    <InputLabel
                        htmlFor="micrphone-selector"
                        className={`setting-item__label`}
                    >
                        global inference interval
                    </InputLabel>
                    <Slider
                        defaultValue={globalInfereceInterval}
                        // getAriaValueText={valuetext}
                        aria-labelledby="discrete-slider"
                        valueLabelDisplay="auto"
                        step={50}
                        marks
                        min={50}
                        max={500}
                        onChange={(event, newValue) => {
                            updateCameraStatus({
                                globalInfereceInterval: newValue,
                            }) && event.stopPropagation()
                        }}
                    />
                </ListItem>
                <ListItem className="setting-item">
                    <InputLabel className={`setting-item__label`}>
                        testVideo
                    </InputLabel>
                    <Typography variant="body1" gutterBottom>
                        {testVideo instanceof File
                            ? testVideo.name
                            : 'No test video'}
                    </Typography>
                    <input
                        accept="video/*"
                        style={{ display: 'none' }}
                        id="raised-button-file"
                        type="file"
                        onChange={(e) => {
                            const file = e.target.files[0]
                            if (file instanceof File) {
                                console.debug('[FILE] ', file)
                                updateCameraStatus({
                                    testVideo: file,
                                }) && e.stopPropagation()
                            }
                        }}
                    />
                    <label htmlFor="raised-button-file">
                        <ButtonGroup
                            variant="contained"
                            color="primary"
                            aria-label="contained primary button group"
                        >
                            <Button
                                variant="outlined"
                                component="span"
                                color="secondary"
                            >
                                {' '}
                                Upload{' '}
                            </Button>
                            <Button
                                onClick={(event) => {
                                    updateCameraStatus({
                                        testVideo: null,
                                    }) && event.stopPropagation()
                                }}
                            >
                                {' '}
                                Clear{' '}
                            </Button>
                        </ButtonGroup>
                    </label>
                </ListItem>

                {/* <ListItem className="setting-item">
                    <InputLabel className={`setting-item__label`}>
                        DB export/import
                    </InputLabel>
                    <Typography variant="body1" gutterBottom>
                        {dbFile instanceof File ? dbFile.name : 'No test video'}
                    </Typography>
                    <input
                        accept=".db"
                        style={{ display: 'none' }}
                        id="db-button-file"
                        type="file"
                        onChange={(e) => {
                            const file = e.target.files[0]
                            if (file instanceof File) {
                                console.debug('[FILE] ', file)
                                updateCameraStatus({
                                    dbFile: file,
                                }) && e.stopPropagation()
                            }
                        }}
                    />
                    <label htmlFor="db-button-file">
                        <ButtonGroup
                            variant="contained"
                            color="primary"
                            aria-label="contained primary button group"
                        >
                            <Button
                                variant="outlined"
                                component="span"
                                color="secondary"
                            >
                                {' '}
                                Import{' '}
                            </Button>
                            <Button
                                onClick={(event) => {
                                    updateCameraStatus({
                                        dbFile: `[save] ${new Date().getTime()}`,
                                    }) && event.stopPropagation()
                                }}
                            >
                                {' '}
                                Export{' '}
                            </Button>
                        </ButtonGroup>
                    </label>
                </ListItem> */}

                <ListItem className="setting-item">
                    <InputLabel className={`setting-item__label`}>
                        testImage
                    </InputLabel>
                    <Typography variant="body1" gutterBottom>
                        {testImage instanceof File
                            ? testImage.name
                            : 'No test video'}
                    </Typography>
                    <input
                        accept="image/*"
                        style={{ display: 'none' }}
                        id="test-img-button-file"
                        type="file"
                        onChange={(e) => {
                            const file = e.target.files[0]
                            if (file instanceof File) {
                                console.debug('[FILE] ', file)
                                updateCameraStatus({
                                    testImage: file,
                                }) && e.stopPropagation()
                            }
                        }}
                    />
                    <label htmlFor="test-img-button-file">
                        <ButtonGroup
                            variant="contained"
                            color="primary"
                            aria-label="contained primary button group"
                        >
                            <Button
                                variant="outlined"
                                component="span"
                                color="secondary"
                            >
                                {' '}
                                Upload{' '}
                            </Button>
                            <Button
                                onClick={(event) => {
                                    updateCameraStatus({
                                        testVideo: null,
                                    }) && event.stopPropagation()
                                }}
                            >
                                {' '}
                                Clear{' '}
                            </Button>
                        </ButtonGroup>
                    </label>
                </ListItem>
            </List>
        </Dialog>
    )
}
